<button class="hashtag" (click)="clicked.emit(hashtag)">{{ hashtag }}</button>
